var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"zl-card-title"},[_c('h3',{staticClass:"zl-title-text"},[_c('div',{staticClass:"slot"},[_vm._t("title",function(){return [_vm._v(_vm._s(_vm.title))]})],2)]),_c('div',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }